import { format, parseISO } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import $api2 from '@/plugins/axiosInstance2.js'
import CONST from '@/const.js'
import isEmpty from 'lodash/isEmpty'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  
 
    GET_APPLICATION: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/application`, params: payload})
            .then(result =>{return result.data})
        }
    },
    GET_APPLICATION_DETAIL: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/application/${payload.id}`, params: payload.params})
            .then(result =>{return result.data})
        }
    },
     
    PUT_APPLICATION_APPROVE: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "put", url:`/application/${payload.id}/approve`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    PUT_APPLICATION_REJECT: {
        root: true,
        handler(namespacedContext, payload){
            return $api2({method: "put", url:`/admin/application/${payload.id}/reject`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    PUT_APPLICATION_HOLD: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "put", url:`/application/${payload.id}/hold`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },

    PUT_APPLICATION_MEMO: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "put", url:`/application/${payload.id}/memo`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    PUT_APPLICATION_TRASH: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "put", url:`/application/${payload.id}/trash`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    PUT_APPLICATION_RESTORE: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "put", url:`/application/${payload.id}/restore`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    
    GET_CALENDAR_MONTH_ALBUM: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/calendar/month/album`, params: payload})
            .then(result =>{return result.data})
        }
    },
    GET_CALENDAR_MONTH: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/calendar/month`, params: payload})
            .then(result =>{return result.data})
        }
    },
    GET_CALENDAR_WEEK: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/calendar/week`, params: payload})
            .then(result =>{return result.data})
        }
    },
    GET_CALENDAR_DAY: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/calendar/day`, params: payload})
            .then(result =>{return result.data})
        }
    },
    PUT_SLOT_DAY: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "put", url:`/calendar/slot/day`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    PUT_SLOT_MONTH: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "put", url:`/calendar/slot/month`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
